module.exports = __webpack_public_path__ + "img/ez-slot-category-sport.6db52b90.png";